import { combineReducers } from 'redux'
import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { commission, peoples, members } from '../../../api/commission'
import { START } from '../../../constants/action-postfix'
import { createActions } from '../../factory/actionFactory'
import { commissionListReducer } from './list/commissionListReducer'
import { commissionLoaderReducer } from './loader/commissionLoaderReducer'
import { currentReducer } from './current/currentReducer'
import { getNormalBody } from '../../../utils/commission'
import { NotificationManager } from 'react-notifications'



import {
  COMMISSION_LIST_REQUEST,
  COMMISSION_GET_REQUEST,
  COMMISSION_CREATE_REQUEST,
  COMMISSION_UPDATE_REQUEST,
  COMMISSION_DELETE_REQUEST,
  COMMISSION_PEOPLES_REQUEST,
  COMMISSION_MEMBERS_REQUEST,
  COMMISSION_MEMBER_ADD_REQUEST,
  COMMISSION_MEMBER_DELETE_REQUEST,
  COMMISSION_MEMBER_UPDATE_REQUEST,
} from './commissionActionTypes'

export const commissionReducer = combineReducers({
  list:    commissionListReducer,
  loader:  commissionLoaderReducer,
  current: currentReducer,
})

// Actions
export const commissionListActions         = createActions('commissionList',         COMMISSION_LIST_REQUEST)
export const commissionGetActions          = createActions('commissionGet',          COMMISSION_GET_REQUEST)
export const commissionCreateActions       = createActions('commissionCreate',       COMMISSION_CREATE_REQUEST)
export const commissionUpdateActions       = createActions('commissionUpdate',       COMMISSION_UPDATE_REQUEST)
export const commissionDeleteActions       = createActions('commissionDelete',       COMMISSION_DELETE_REQUEST)
export const commissionPeoplesActions       = createActions('commissionPeoples',      COMMISSION_PEOPLES_REQUEST)
export const commissionMembersActions      = createActions('commissionMembers',      COMMISSION_MEMBERS_REQUEST)
export const commissionMemberAddActions    = createActions('commissionMemberAdd',    COMMISSION_MEMBER_ADD_REQUEST)
export const commissionMemberUpdateActions    = createActions('commissionMemberUpdate',    COMMISSION_MEMBER_UPDATE_REQUEST)
export const commissionMemberDeleteActions = createActions('commissionMemberDelete', COMMISSION_MEMBER_DELETE_REQUEST)

// Watcher
export function* commissionWatcher() {
  yield all([
    takeLatest(`${COMMISSION_LIST_REQUEST}${START}`,          commissionListWorker),
    takeLatest(`${COMMISSION_GET_REQUEST}${START}`,           commissionGetWorker),
    takeLatest(`${COMMISSION_CREATE_REQUEST}${START}`,        commissionCreateWorker),
    takeLatest(`${COMMISSION_UPDATE_REQUEST}${START}`,        commissionUpdateWorker),
    takeLatest(`${COMMISSION_DELETE_REQUEST}${START}`,        commissionDeleteWorker),
    takeLatest(`${COMMISSION_PEOPLES_REQUEST}${START}`,       commissionPeoplesWorker),
    takeLatest(`${COMMISSION_MEMBERS_REQUEST}${START}`,       commissionMembersWorker),
    takeLatest(`${COMMISSION_MEMBER_ADD_REQUEST}${START}`,    commissionMemberAddWorker),
    takeLatest(`${COMMISSION_MEMBER_UPDATE_REQUEST}${START}`,    commissionMemberUpdateWorker),
    takeLatest(`${COMMISSION_MEMBER_DELETE_REQUEST}${START}`, commissionMemberDeleteWorker),
  ])
}

// Workers
function* commissionListWorker({ payload }) {
  try {
    const auth = yield select(state => state.auth.data)
    const params = {...payload, ...auth} 
    const response = yield call(commission.get, params)
    yield put(commissionListActions.commissionListRequestSuccess(response.data.Answer.Data))
  } catch (error) {
    yield put(commissionListActions.commissionListRequestError(error))
  }
}

function* commissionGetWorker({ payload }) {
  try {
    const auth = yield select(state => state.auth.data)
    const params = {...payload, ...auth} 
    const response = yield call(commission.getById, params)
    yield put(commissionGetActions.commissionGetRequestSuccess(getNormalBody(response.data.Answer.Data[0])))
  } catch (error) {
    yield put(commissionGetActions.commissionGetRequestError(error))
  }
}

function* commissionCreateWorker({ payload }) {
  try {
    const auth = yield select(state => state.auth.data)
    const params = {...payload, ...auth} 
    const response = yield call(commission.create, params)
    const {Result} = response.data.Answer
    if (Result === 'Success') {
      yield put(commissionListActions.commissionListRequestStart())
    } else {
      NotificationManager.error('Ошибка создания комиссии')
    }
    yield put(commissionCreateActions.commissionCreateRequestSuccess(response.data))
  } catch (error) {
    yield put(commissionCreateActions.commissionCreateRequestError(error))
  }
}

function* commissionUpdateWorker({ payload }) {
  try {
    const auth = yield select(state => state.auth.data)
    const params = {...payload, ...auth} 
    const response = yield call(commission.update, params)
    yield put(commissionUpdateActions.commissionUpdateRequestSuccess(payload))
  } catch (error) {
    yield put(commissionUpdateActions.commissionUpdateRequestError(error))
  }
}

function* commissionDeleteWorker({ payload }) {
  try {
    const auth = yield select(state => state.auth.data)
    const params = {...payload, ...auth} 
    const response = yield call(commission.delete, params)
    const {Result} = response.data.Answer
    if (Result === 'Success') {
      yield put(commissionListActions.commissionListRequestStart())
    } else {
      NotificationManager.error('Ошибка удаления комиссии')
    }
    yield put(commissionDeleteActions.commissionDeleteRequestSuccess(response.data))
  } catch (error) {
    yield put(commissionDeleteActions.commissionDeleteRequestError(error))
  }
}

function* commissionPeoplesWorker({ payload }) {
  try {
    const auth = yield select(state => state.auth.data)
    const params = {...payload, ...auth} 
    const response = yield call(peoples.get, params)
    yield put(commissionPeoplesActions.commissionPeoplesRequestSuccess(response.data.Answer.Data))
  } catch (error) {
    yield put(commissionPeoplesActions.commissionPeoplesRequestError(error))
  }
}

function* commissionMembersWorker({ payload }) {
  try {
    const auth = yield select(state => state.auth.data)
    const params = {...payload, ...auth} 
    const response = yield call(members.get, params)
    yield put(commissionMembersActions.commissionMembersRequestSuccess(response.data.Answer.Data))
  } catch (error) {
    yield put(commissionMembersActions.commissionMembersRequestError(error))
  }
}

function* commissionMemberAddWorker({ payload }) {
  try {
    const auth = yield select(state => state.auth.data)
    const params = {...payload, ...auth} 
    const response = yield call(members.add, params)
    const {Result} = response.data.Answer
    if (Result === 'Success') {
      yield put(commissionMembersActions.commissionMembersRequestStart({ id: payload.commission_id }))
    } else {
      NotificationManager.error('Ошибка добавления участника')
    }
    yield put(commissionMemberAddActions.commissionMemberAddRequestSuccess(response.data))
  } catch (error) {
    yield put(commissionMemberAddActions.commissionMemberAddRequestError(error))
  }
}

function* commissionMemberUpdateWorker({ payload }) {
  try {
    const auth = yield select(state => state.auth.data)
    const params = {...payload, ...auth} 
    const response = yield call(members.update, params)
    yield put(commissionMemberUpdateActions.commissionMemberUpdateRequestSuccess(response.data))
  } catch (error) {
    yield put(commissionMemberUpdateActions.commissionMemberUpdateRequestError(error))
  }
}

function* commissionMemberDeleteWorker({ payload }) {
  try {
    const auth = yield select(state => state.auth.data)
    const comId = yield select(state => state.commission.current.data.id)
    const params = {...payload, ...auth}
    const response = yield call(members.delete, params)
    const {Result} = response.data.Answer
    if (Result === 'Success') {
      yield put(commissionMembersActions.commissionMembersRequestStart({ id: comId }))
    }
    yield put(commissionMemberDeleteActions.commissionMemberDeleteRequestSuccess(response.data))
  } catch (error) {
    yield put(commissionMemberDeleteActions.commissionMemberDeleteRequestError(error))
  }
}

